import { ArrowLeftIcon, UserPlus2Icon } from "lucide-react"
import { useState } from "react"
import { useForm } from "react-hook-form"
import { Link } from "react-router-dom"

import { AppDateInput } from "@/components"
import { ClipboardButton } from "@/components/commons/clipboard-button"
import { Button } from "@/components/ui/button"
import {
  Card,
  CardContent,
  CardDescription,
} from "@/components/ui/card"
import { Checkbox } from "@/components/ui/checkbox"
import { ComboBox } from "@/components/ui/combo-box"
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import {
  RadioGroup,
  RadioGroupItem,
} from "@/components/ui/radio-group"
import { useSidebar } from "@/components/ui/sidebar"
import { FRONTEND_ROUTES } from "@/constants"
import { formatDate } from "@/helpers/format"
export const SubscriptionsCreateRecurrenceForm = () => {
  const { open } = useSidebar()
  const form = useForm()
  const [customerChecked, setCustomerChecked] =
    useState(false)
  const [isToday, setIsToday] = useState(false)
  const today = new Date()
  const handleToggleIsTodayCheckbox = (
    v: boolean | "indeterminate"
  ) => {
    setIsToday(Boolean(v))
    if (v) {
      form.setValue("start_date", new Date())
    } else {
      form.setValue("start_date", null)
    }
  }
  const paymentMethodItems = [
    {
      label: "Cartão de crédito",
      value: "credit_card",
      description:
        "1,99% a.vista / 2-6x 2,39% / 7-12 2,79%",
    },
    {
      label: "Pix",
      value: "pix",
      description: "R$ 0,25 por pix recebido",
    },
    {
      label: "Pix Open Finance",
      value: "pix_open_finance",
      description: "R$ 0,18 por pix recebido",
    },
    {
      label: "Boleto",
      value: "boleto",
      description:
        "1,99% a.vista / 2-6x 2,39% / 7-12 2,79%",
    },
    {
      label: "Nupay",
      value: "nupay",
      description:
        "1,99% a.vista / 2-6x 2,39% / 7-12 2,79%",
    },
    {
      label: "Pontos Livelo",
      value: "pontos_livelo",
      description:
        "1,99% a.vista / 2-6x 2,39% / 7-12 2,79%",
    },
  ]
  return (
    <Form {...form}>
      <form
        action=""
        className="group space-y-4"
        data-sidebar-open={open}
      >
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          <FormField
            control={form.control}
            name="customer"
            render={() => (
              <FormItem>
                <FormLabel>Cliente</FormLabel>
                <FormControl>
                  <ComboBox
                    items={[]}
                    onSelect={() => {}}
                    selected={null}
                    placeholder="Selecione um cliente"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="customer"
            render={() => (
              <FormItem>
                <FormLabel>Plano</FormLabel>
                <FormControl>
                  <ComboBox
                    items={[]}
                    onSelect={() => {}}
                    selected={null}
                    placeholder="Selecione um plano"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <div
            className="flex items-end justify-end data-[has-error=true]:mb-7 sm:col-span-2 lg:col-span-1 lg:justify-start"
            data-has-error={form.formState.errors}
          >
            <Button
              type="button"
              variant="link"
              className="text-zinc-950"
            >
              + Adicionar produto
            </Button>
          </div>
        </div>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 group-data-[sidebar-open=true]:lg:grid-cols-2">
          <FormField
            control={form.control}
            name="amount"
            render={({ field }) => (
              <FormItem>
                <FormLabel>
                  Valor R$ (cobrado a cada período)
                </FormLabel>
                <FormControl>
                  <Input {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="description"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Descrição</FormLabel>
                <FormControl>
                  <Input {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
        <div
          data-has-error={form.formState.errors}
          className="grid items-end gap-4 sm:grid-cols-2 group-data-[sidebar-open=false]:lg:grid-cols-4 xl:grid-cols-4"
        >
          <FormField
            control={form.control}
            name="amount_installments"
            render={({ field }) => (
              <FormItem>
                <FormLabel>
                  Cobrar a cada período de
                </FormLabel>
                <FormControl>
                  <Input {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="amount_installments"
            render={() => (
              <FormItem>
                <FormLabel>Período</FormLabel>
                <FormControl>
                  <ComboBox
                    items={[]}
                    onSelect={() => {}}
                    selected={null}
                    placeholder="Selecione um período"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="start_date"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Primeira cobrança em</FormLabel>
                <FormControl>
                  <AppDateInput
                    disabledField={isToday}
                    onSelect={() => {}}
                    fromDate={new Date()}
                    selected={field.value}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <div className="flex h-10 items-center gap-2">
            <Checkbox
              id="is-today"
              checked={isToday}
              onCheckedChange={(v) =>
                handleToggleIsTodayCheckbox(v)
              }
            />
            <Label htmlFor="is-today">
              Hoje - {formatDate({ date: today })}
            </Label>
          </div>
        </div>
        <FormField
          control={form.control}
          name="radio"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Quantos ciclos?</FormLabel>
              <FormControl>
                <RadioGroup
                  defaultValue={field.value}
                  onValueChange={field.onChange}
                >
                  <div className="flex flex-col gap-4 sm:flex-row">
                    <Card className="w-full p-0 sm:max-w-72">
                      <CardContent className="flex flex-col gap-2 p-4">
                        <FormItem className="flex items-center space-x-3 space-y-0">
                          <FormControl>
                            <RadioGroupItem value="1" />
                          </FormControl>
                          <FormLabel>
                            Pré-definidos
                          </FormLabel>
                        </FormItem>
                        <FormField
                          control={form.control}
                          name="max"
                          render={({ field }) => (
                            <FormItem>
                              <FormLabel>
                                Máximo de cobranças
                              </FormLabel>
                              <FormControl>
                                <Input {...field} />
                              </FormControl>
                              <FormMessage />
                            </FormItem>
                          )}
                        />
                      </CardContent>
                    </Card>
                    <Card className="w-full p-0 sm:max-w-72">
                      <CardContent className="flex flex-col gap-2 p-4">
                        <FormItem className="flex items-center space-x-3 space-y-0">
                          <FormControl>
                            <RadioGroupItem value="2" />
                          </FormControl>
                          <FormLabel>Indefinidos</FormLabel>
                        </FormItem>
                        <CardDescription>
                          A cobrança será feita na
                          periodicidade informada até que
                          seja a assinatura seja encerrada
                        </CardDescription>
                      </CardContent>
                    </Card>
                  </div>
                </RadioGroup>
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <div className="flex flex-col items-start justify-between gap-4 lg:flex-col group-data-[sidebar-open=true]:lg:flex-col xl:flex-row">
          <FormField
            control={form.control}
            name="paymentMethods"
            render={() => (
              <FormItem className="w-full">
                <div className="grid gap-4 md:grid-cols-[18rem_1fr]">
                  <FormLabel>
                    Método(s) de pagamento
                  </FormLabel>
                  <div className="flex items-center gap-2">
                    <Checkbox
                      id="customer-checked"
                      checked={customerChecked}
                      onCheckedChange={() =>
                        setCustomerChecked(!customerChecked)
                      }
                    />
                    <Label htmlFor="customer-checked">
                      Cliente escolhe
                    </Label>
                  </div>
                </div>
                <Card className="w-full max-w-2xl p-0">
                  <CardContent className="flex w-full flex-col gap-4 p-4">
                    {paymentMethodItems.map((item) => (
                      <FormField
                        key={item.value}
                        control={form.control}
                        name="paymentMethods"
                        render={() => {
                          return (
                            <FormItem key={item.value}>
                              <div className="flex flex-col max-md:gap-2 md:grid md:grid-cols-[18rem_1fr]">
                                <FormLabel>
                                  {item.label}
                                </FormLabel>
                                <div className="flex items-start gap-2 space-y-0 md:items-center">
                                  <FormControl>
                                    <Checkbox
                                      disabled={
                                        customerChecked
                                      }
                                    />
                                  </FormControl>
                                  <p className="text-sm">
                                    {item.description}
                                  </p>
                                </div>
                              </div>
                            </FormItem>
                          )
                        }}
                      />
                    ))}
                  </CardContent>
                </Card>
              </FormItem>
            )}
          />
          <div className="w-full group-data-[sidebar-open=false]:xl:w-fit">
            <div className="space-y-4">
              <FormField
                control={form.control}
                name="paymentLink"
                render={({ field }) => (
                  <FormItem className="max-w-2xl">
                    <FormLabel>Link de pagamento</FormLabel>
                    <div className="flex items-center gap-2">
                      <FormControl>
                        <Input {...field} disabled />
                      </FormControl>
                      <ClipboardButton
                        text={field.value}
                        disabled={!field.value}
                      />
                    </div>
                    <FormMessage />
                  </FormItem>
                )}
              />
              <div className="flex items-center gap-2">
                <Checkbox />
                <Label>
                  Compartilhar link de pagamento por e-mail
                </Label>
              </div>
            </div>
            <div className="mt-16 flex flex-col-reverse items-center justify-end gap-4 sm:flex-row">
              <Button
                type="button"
                asChild
                variant="outline"
                className="max-sm:w-full sm:min-w-40"
              >
                <Link
                  to={FRONTEND_ROUTES.SUBSCRIPTIONS.href}
                >
                  <ArrowLeftIcon
                    size={18}
                    className="mr-2"
                  />
                  <span>Cancelar</span>
                </Link>
              </Button>
              <Button
                type="submit"
                className="max-sm:w-full sm:min-w-40"
              >
                <UserPlus2Icon size={18} className="mr-2" />
                <span>Criar</span>
              </Button>
            </div>
          </div>
        </div>
      </form>
    </Form>
  )
}
